<div #popup class=" mat-dialog-edition-form" appDraggable>
    <div class="popup-header d-flex justify-content-between align-items-center">
      <h2 class="title mx-auto text-center w-100 fs-6">
  
        {{ isNew ? ('SETTINGS.NEW_SITE' | translate) : ('SETTINGS.MODIFY_SITE'
        |
        translate) }}
  
      </h2>
      <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
        (click)="onClose()"></button>
    </div>

          <!-- CONTENT -->
  <div class="popup-content">
    <form class="form" [formGroup]="form!" (ngSubmit)="onSubmit()" id="ngForm">

      <!-- ROW 1 -->
      <div class="d-flex">
        <div class="row-item-width-50 input-container">
          <label class="input-label">{{ 'SETTINGS.NAME' | translate }}</label>
          <input class="input-field" id="name" placeholder="{{ 'SETTINGS.NAME' | translate }}" formControlName="name" name="name" type="text" />
          @if(form?.get('name')?.invalid && form?.get('name')?.touched){
          <div class="input-errors">
            @if(form?.get('name')?.errors?.['required']){
            <span>{{ 'SETTINGS.NAME_REQUIRED' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="region">{{ 'SETTINGS.REGION' | translate }}</label>
              
              <ng-select
                name="region"
                id="region"
                [items]="regions"
                bindLabel="name"
                bindValue="regionId"
                formControlName="region"
                [multiple]="false"
                [closeOnSelect]="true"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.REGION' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('region')?.invalid && form?.get('region')?.touched) {
                <div class="input-errors">
                  @if (form?.get('region')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.AREA_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div>
          
      </div>
       <!-- ROW 2 -->
      <div class="d-flex">
        <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label" for="country">{{ 'SETTINGS.COUNTRY' | translate }}</label>
              <ng-select
                name="country"
                id="country"
                [items]="countries"
                bindLabel="nomEn"
                bindValue="paysId"
                formControlName="country"
                [multiple]="false"
                [closeOnSelect]="true"
                [hideSelected]="true"
                [searchable]="true"
                notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
                placeholder="{{ 'SETTINGS.COUNTRY' | translate }}"
              >
              </ng-select>
          
              @if (form?.get('country')?.invalid && form?.get('country')?.touched) {
                <div class="input-errors">
                  @if (form?.get('country')?.errors?.['required']) {
                    <span>{{ 'SETTINGS.COUNTRY_REQUIRED' | translate }}</span>
                  }
                </div>
              }
            </div>
          </div>

          <div class="col-6 input-container">
            <div class="row-item-width-100 input-container">
              <label class="input-label">{{ 'SETTINGS.SITE_EPSG' | translate }}</label>
              <ng-select
                [items]="filteredEpsgSiteCodes"
                [typeahead]="typeaheadSite$"
                bindLabel="text"
                bindValue="id"
                placeholder="{{ 'PLACEHOLDERS.SEARCH_EPSG' | translate }}"
                typeToSearchText="{{ 'PLACEHOLDERS.TYPE_TO_SEARCH' | translate }}"
                formControlName="epsgSite"
                [searchable]="true"
                [virtualScroll]="true"
                [compareWith]="compareItems"
                [loading]="loadingEpsgSite"
              ></ng-select>
              @if (form.get('epsgSite')?.invalid && form.get('epsgSite')?.touched) {
                <div class="input-errors">
                  <span>{{ 'ERRORS.INVALID_EPSG' | translate }}</span>
                </div>
              }
            </div>
          </div>
          
      </div>

      <div class="d-flex">
        <div class="col-6 input-container">
          <div class="row-item-width-100 input-container">
            <label class="input-label">{{ 'FORM.STANDARD_COMPLIANCE_LABEL' | translate }}</label>
            <ng-select 
              [items]="ponderations" 
              bindLabel="name" 
              bindValue="standardCode"
              [(ngModel)]="selectedStandardCode"
              [ngModelOptions]="{standalone: true}"
              (change)="onPonderationChange($event)"
              [multiple]="false"
              [closeOnSelect]="true"
              [hideSelected]="false"
              [searchable]="false">
            </ng-select>
          </div>
        </div>
      </div>
      <!-- card -->
      <div class="card">
        <div class="col-12 input-container">
          <div class="row-item-width-100 input-container">
            <label class="input-label">{{ 'FORM.EPSG' | translate }}</label>
            <ng-select
              [items]="filteredEpsgCodes"
              [typeahead]="typeahead$"
              bindLabel="text"
              bindValue="id"
              placeholder="{{ 'PLACEHOLDERS.SEARCH_EPSG' | translate }}"
              typeToSearchText="{{ 'PLACEHOLDERS.TYPE_TO_SEARCH' | translate }}"
              formControlName="epsg"
              [searchable]="true"
              [virtualScroll]="true"
              [compareWith]="compareItems"
              [loading]="loadingEpsg"
            ></ng-select>
            @if (form.get('epsg')?.invalid && form.get('epsg')?.touched) {
              <div class="input-errors">
                <span>{{ 'ERRORS.INVALID_EPSG' | translate }}</span>
              </div>
            }
          </div>
        </div>
          <div class="d-flex">
            <div class="col-6 input-container">
              <div class="row-item-width-100 input-container">
                <label class="input-label">X</label>
                <input class="input-field" id="x" placeholder="X" formControlName="x" name="x" type="number" />
                @if(form?.get('x')?.invalid && form?.get('x')?.touched){
                <div class="input-errors">
                  @if(form?.get('x')?.errors?.['required']){
                  <span>{{ 'SETTINGS.X_REQUIRED' | translate }}</span>
                  }
                </div>
                }
              </div>
            </div>
            <div class="col-6 input-container">
              <div class="row-item-width-100 input-container">
                <label class="input-label">Y</label>
                <input class="input-field" id="y" placeholder="Y" formControlName="y" name="y" type="number" />
                @if(form?.get('y')?.invalid && form?.get('y')?.touched){
                <div class="input-errors">
                  @if(form?.get('y')?.errors?.['required']){
                  <span>{{ 'SETTINGS.Y_REQUIRED' | translate }}</span>
                  }
                </div>
                }
              </div>
            </div>
          </div>
         
    </div>
    <div class="d-flex">
      <div class="col-6 input-container">
        <div class="mb-3 toggle-container" style="flex: 1;">
          <div class="toggle-wrapper d-flex align-items-center">
            <label class="form-check-label me-2 mb-0" for="isActif">
              {{ 'SETTINGS.ACTIVE' | translate }}
            </label>
            <label class="switch mb-0">
              <input type="checkbox" id="isActif" formControlName="isActif" />
              <span class="slider round"></span>
            </label>
          </div>
          
      </div>
      </div>
    </div>

    </form>
    </div>
    <div class="popup-footer">
        <button class="secondary-button popup-secondary-button" (click)="onClose()">{{ 'BUTTONS.CANCEL' | translate }}</button>
        <button class="primary-button popup-primary-button" form="ngForm" type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
      </div>
</div>